var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('bannera',{attrs:{"bannerImg":_vm.bannerImg,"bannerImg1":_vm.bannerImg1,"wenziImg":_vm.wenziImg,"wenziImg1":_vm.wenziImg1}}),_c('contenta'),_c('footera')],1)}
var staticRenderFns = []

export { render, staticRenderFns }